import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tooltip" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "tooltip-content" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Popover = _resolveComponent("Popover")

  return (_openBlock(), _createBlock(_component_Popover, {
    class: "popover-wrapper",
    "popper-class": "pulse-tooltip",
    teleported: false,
    disabled: $options.disable_tooltip,
    placement: "top",
    trigger: "hover",
    "show-after": 700,
    persistent: false
  }, {
    reference: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString($props.title), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_3, _toDisplayString($props.content), 1 /* TEXT */)
      ])
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["disabled"]))
}